import React from 'react';

import type { DynamicBanner as DynamicBannerType, ImageFetchProps } from '../../model/types';

import CompetitionBanner from './CompetitionBanner';
import EventBanner from './EventBanner/EventBanner';
import EventTypeBanner from './EventTypeBanner';
import MarketBanner from './MarketBanner/MarketBanner';

const DynamicBanner: React.FC<DynamicBannerType & ImageFetchProps> = (props) => {
  switch (props.bannerType) {
    case 'MARKET':
      return <MarketBanner {...props} />;
    case 'EVENT':
      return <EventBanner {...props} />;
    case 'COMPETITION':
      return <CompetitionBanner {...props} />;
    default:
      return <EventTypeBanner {...props} />;
  }
};

export default DynamicBanner;
